import { IBuilderComponent } from "@faire/web/builder/registerBuilderComponents/types";
import { BaseButtonProps } from "@faire/web/slate/Button/types";
import { trackClientEvent } from "@faire/web-api/trackClientEvent";

export interface IAdditionalProps {
  eventKeyOnClick: string;
  textContent: string;
}

export const BuilderConfig: IBuilderComponent<
  BaseButtonProps,
  IAdditionalProps
> = {
  name: "Button",
  relativePath: "./Button.tsx",
  propDefinition: {
    name: "ButtonProps",
    path: "./types.ts",
    unravelTypes: "BaseButtonProps",
  },
  transformations: {
    onClick: (props) => {
      return () => {
        trackClientEvent({
          eventKey: props.eventKeyOnClick,
        });
      };
    },
    "data-test-id": null,
    buttonRef: null,
    children: (props) => props.textContent,
    loading: null,
  },
  defaultValues: {
    variant: "primary",
    textContent: "Button Text",
  },
  canHaveChildren: false,
  localizedFields: ["textContent"],
};
